// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";

function V3CustomTable$GridMatchLeftToRight(props) {
  return React.createElement("div", {
              className: "w-full m-5"
            }, props.children);
}

var GridMatchLeftToRight = {
  make: V3CustomTable$GridMatchLeftToRight
};

function V3CustomTable$GridMatchRightToLeft(props) {
  return React.createElement("div", {
              className: "w-full m-5"
            }, props.children);
}

var GridMatchRightToLeft = {
  make: V3CustomTable$GridMatchRightToLeft
};

function V3CustomTable$InstructionAndHint(props) {
  return React.createElement("div", {
              className: ""
            }, props.children);
}

var InstructionAndHint = {
  make: V3CustomTable$InstructionAndHint
};

function V3CustomTable(props) {
  var children = props.children;
  var tableTemplate = props.tableTemplate;
  return React.createElement(V3CustomTableContext$LiteracyplanetTupperware.Provider.make, {
              value: {
                t: tableTemplate,
                numColumns: props.numColumns,
                numRows: props.numRows
              },
              children: tableTemplate === "InstructionAndHint" ? React.createElement(V3CustomTable$InstructionAndHint, {
                      children: children
                    }) : (
                  tableTemplate === "GridMatchLeftToRight" ? React.createElement(V3CustomTable$GridMatchLeftToRight, {
                          children: children
                        }) : React.createElement(V3CustomTable$GridMatchRightToLeft, {
                          children: children
                        })
                )
            });
}

var make = V3CustomTable;

var $$default = V3CustomTable;

export {
  GridMatchLeftToRight ,
  GridMatchRightToLeft ,
  InstructionAndHint ,
  make ,
  $$default as default,
}
/* react Not a pure module */
